$(document).on('resize', function() {
  navigationOnScroll();
});

$(document).on('scroll', function() {
  navigationOnScroll();
});

/* Lleva cualquier #hash de la url a un ID existente en la pagina con una trasicion suave */
function anchorGoToHash() {
  $('a[href*="#"]:not([href="#"])').click(function (e) {
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      if (target.length) {
        $('html, body').animate({
          scrollTop: target.offset().top - 100
        }, 500);
        return false;
      }
    }
  });
}

/* nav styles and actions */
function navigationOnScroll() {
  var st = $(window).scrollTop();

  /* styles to body */
  if (st > 0) {
    $('body').removeClass('is-top');
  } else {
    $('body').addClass('is-top');
  }

  /* styles to nav */
  if (st > 100) {
    $('.navigation').addClass('is-small');
  } else {
    $('.navigation').removeClass('is-small');
  }

  /* styles for hero */
  if($('.hero').length > 0){
    var heroHeight = $('.hero').outerHeight();

    if (st > (heroHeight/3*2)){
      $('.img_parallax').addClass('is-fading');
    } else {
      $('.img_parallax').removeClass('is-fading');
    }

    if($('.hero').hasClass('hero_home')){
      if (st > heroHeight){
        $('.navigation').addClass('is-solid');
      } else {
        $('.navigation').removeClass('is-solid');
      }
    } else {
      if (st > 0){
        $('.navigation').addClass('is-solid');
      } else {
        $('.navigation').removeClass('is-solid');
      }
    }
  }
}

/* nav behavior on trigger */
function triggerMenuNavigation(el) {
  var bars = el.find('.navigation__bars');

  if (bars.hasClass('is-opened')) {
    bars.removeClass('is-opened');
    $('.navigation__menu').hide();
    el.removeClass('is-visible');
    if ( $('.navigation').hasClass('is-transparent') ) {
      $('.navigation').removeClass('is-dark');
    }
  } else {
    bars.addClass('is-opened');
    $('.navigation__menu').show();
    el.addClass('is-visible');
  }
}

function preventDefaultFunction(event) {
  event.preventDefault();
}

function productModalTrigger(){
  $('.modal__trigger').on('click', function(e){
    preventDefaultFunction(e);
    postId = $(this).data('id');

    $.ajax({
      type: 'POST',
      url: myObj.restURL + 'baseUrl/v1/baseEndPoint/productDetailsEndPoint',
      beforeSend: function(xhr){
        xhr.setRequestHeader( 'X-WP-Nonce', myObj.restNonce);
      },
      data: {
        'id': postId
      },
      success: function(response){
        if(response){
          $('.modal__info, .modal__img').empty();
          $('.modal__info').html(
            '<h4 class="ft-blue">'+response.post_title+'</h4>'+
            response.post_content
          );
          $('.modal__img').html(response.post_image);
          console.log(response);
        }
      }
    });

    $('.modal__overlay').addClass('is-open');
  })
  $('.modal__close').on('click', function(e){
    preventDefaultFunction(e);
    $('.modal__overlay').removeClass('is-open');
  })
}

function formStyles(){

  // Labels states
  $('.form__input').each(function(){
    $(this).addClass('is-label-down');
  });

  $('.form__input input, .form__input textarea').each(function() {
    var me = $(this),
        parent = me.parent().parent();

    if( me.val() == '' || me.val() == undefined ) {
      parent.addClass('is-label-down');
    } else {
      parent.removeClass('is-label-down');
    }
  });

  $('.form__input').find('input, textarea').on('keyup blur focus', function(e){

    // Cache our selectors
    var me = $(this),
        parent = me.parent().parent();

    // Add or remove classes
    if (e.type == 'keyup') {
      if( me.val() == '' ) {
        parent.addClass('is-label-down');
      } else {
        parent.removeClass('is-label-down');
      }
    } else if (e.type == 'blur') {
      if( me.val() == '' ) {
        parent.addClass('is-label-down');
      }
      else {
        parent.removeClass('is-label-down');
      }
    } else if (e.type == 'focus') {
      parent.removeClass('is-label-down');
    }
  });
}

function socialShare() {
  // Compartir en redes sociales: reemplazar "version" por 'mobile' o 'landing' según corresponda
  // No usar "|" (pipe) o caracteres especiales en el <title> del html
  var myUrl = window.location.href,
      title = encodeURIComponent($(document).find("title").html()),
      facebook = 'https://www.facebook.com/sharer/sharer.php?u='+myUrl+'',
      Xtwitter = 'https://x.com/intent/post?url='+encodeURIComponent(myUrl)+'&text='+title+'';

  if ($('.share__actions').length > 0) {
    // Compartir en Facebook
    $('.share_facebook').on('click', function(event) {
      event.preventDefault();
      window.open(facebook, 'Compartir en Facebook', 'width=500,height=500,resizable=1');
    });

    // Compartir en X
    $('.share_x').on('click', function(event) {
      event.preventDefault();
      window.open(Xtwitter, 'Compartir en X', 'width=500,height=500,resizable=1');
    });
  }
}

function copyToClipboard(){
  $('.share_copy').on('click', function(e){
    let post = $(location).attr("href"),
        tooltip = $(this).find('.tooltip');

    preventDefaultFunction(e);
    navigator.clipboard.writeText(post);
    
    $(tooltip).removeClass('fade-out').addClass('fade-in');
    setTimeout(
      function(){
        $(tooltip).removeClass('fade-in').addClass('fade-out')
      }, 2000);
  });
}